export default {
  namespaced: true,
  state: {
    showSidebar: true,
    sidebarActiveElement: null,
    sidebarCollapsed: false,
    chatOpen: false,
    chatNotificationIcon: false,
    chatNotificationPopover: false,
    showSearchInputInHeader: false,
    searchTerm: "",
    hasFeedsFilters: false,
  },
  mutations: {
    toggleSidebar(state) {
      state.showSidebar = !state.showSidebar;
    },
    switchSidebar(state, value) {
      if (value !== undefined) {
        state.showSidebar = value;
      }
    },
    toggleSidebarCollapse(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
      // Save to localStorage for persistence
      localStorage.setItem("sidebarCollapsed", state.sidebarCollapsed);
    },
    setSidebarCollapse(state, value) {
      state.sidebarCollapsed = value;
    },
    handleSwipe(state, e) {
      if ("ontouchstart" in window) {
        if (e.direction === 4) {
          // Swipe right - show sidebar
          state.showSidebar = true;
        }

        if (e.direction === 2) {
          // Swipe left - hide sidebar or collapse
          state.showSidebar = false;
        }
      }
    },
    changeSidebarActive(state, index) {
      state.sidebarActiveElement = index;
    },
    setSearchInputVisibilityInHeader(state, visibility) {
      state.showSearchInputInHeader = visibility;
    },
    updateSearchTerm(state, searchTerm) {
      state.searchTerm = searchTerm;
    },
    updateFeedsFilterStatus(state, status) {
      state.hasFeedsFilters = status;
    },
  },
  actions: {
    toggleSidebar({ commit }) {
      commit("toggleSidebar");
    },
    switchSidebar({ commit }, value) {
      commit("switchSidebar", value);
    },
    toggleSidebarCollapse({ commit }) {
      commit("toggleSidebarCollapse");
    },
    setSidebarCollapse({ commit }, value) {
      commit("setSidebarCollapse", value);
      // Save to localStorage for persistence
      localStorage.setItem("sidebarCollapsed", value);
    },
    handleSwipe({ commit }, e) {
      commit("handleSwipe", e);
    },
    changeSidebarActive({ commit }, index) {
      commit("changeSidebarActive", index);
    },
    setSearchInputVisibilityInHeader({ commit }, visibility) {
      commit("setSearchInputVisibilityInHeader", visibility);
    },
    updateFeedsFilterStatus({ commit }, status) {
      commit("updateFeedsFilterStatus", status);
    },
    updateSearchTerm({ commit }, searchTerm) {
      commit("updateSearchTerm", searchTerm);
    },
    initializeState({ commit, state }) {
      if (window.innerWidth <= 768) {
        state.sidebarCollapsed = true;
      } else {
        const savedState = localStorage.getItem("sidebarCollapsed");
        if (savedState !== null) {
          commit("setSidebarCollapse", savedState === "true");
        }
        commit("switchSidebar", true);
      }
    },
  },
};
